// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"632":"678dd24a","873":"e3825e84"}[chunkId] + ".chunk.css";
};